<template>
  <div v-click-outside="outClose" class="">
    <input
        :class="{'gary-back':(setPlaceHolder()=== 'assignments' &&  CheckUserPermission([7]))}"
      v-if="extSearch"
      v-model="externalSearchQuery"
      class="input-main-multi-select"
      :placeholder="setPlaceHolder()"
      type="search"
      @click="openMultiSelect()"
    />
    <input
      v-if="sector === 'finance_total'"
      class="input-filter-category"
      placeholder="Category"
      type="search"
      @click="openMultiSelect()"
    />
    <input
      v-if="sector === 'finance_methods'"
      class="input-filter-category"
      placeholder="Methods"
      type="search"
      @click="openMultiSelect()"
    />
    <input
      v-if="sector === 'finance_status'"
      class="input-filter-category"
      placeholder="Status"
      type="search"
      @click="openMultiSelect()"
    />
    <input
      v-if="sector === 'finance_currency'"
      class="input-filter-category"
      placeholder="Currency"
      type="search"
      @click="openMultiSelect()"
    />
    <div
      v-if="sector === 'countries'"
      class="time-select"
      @click="openMultiSelect()"
    ></div>

    <div
      v-if="sector === 'sms'"
      class="sms-ext-button"
      @click="openMultiSelect()"
    ></div>

    <div
      v-show="open"
      :style="background.mainBg"
      :class="{
        'r-body-ex-right':
          expandToRight &&
          selectedTab !== 'assignments' &&
          sector !== 'bad_number' &&
          sector !== 'not_interested' &&
          sector !== 'finance_total' &&
          sector !== 'finance_methods' &&
          sector !== 'finance_status' &&
          sector !== 'finance_currency',

        'r-body-ex-right-finance-category': sector === 'finance_total',
        'r-body-ex-right-finance-methods': sector === 'finance_methods',
        'r-body-ex-right-finance-status': sector === 'finance_status',
        'r-body-ex-right-finance-currency': sector === 'finance_currency',

        'r-body-ex-right-sms': expandToRight && sector === 'sms',
        'root-body':
          !expandToRight &&
          sector !== 'questions' &&
          selectedTab !== 'campaign',
        'root-body-for-dep': sector === 'deposits',
        'root-body-for-bn': sector === 'bad_number',
        'root-body-for-ni': sector === 'not_interested',
        'root-body-countries': !expandToRight && sector === 'countries',
        'root-body-countries-expand': expand && sector === 'countries',
        'root-body-questions': !expandToRight && sector === 'questions',
        'root-body-questions-status':
          !expandToRight && sector === 'questions_status',
        'root-body-campaign': !expandToRight && selectedTab === 'campaign',
        'root-body-assignments':
          !expandToRight && selectedTab === 'assignments',
        'root-body-assignments-no-ex':
          expandToRight && selectedTab === 'assignments',
        'root-body-campaign-placement':
          !expandToRight &&
          selectedTab === 'campaign' &&
          sector === 'placement',
        'r-body-ex-right-ranks':
          sector === 'assignments' &&
          (selectedTab === 'rank_1' ||
            selectedTab === 'rank_2' ||
            selectedTab === 'rank_3' ||
            selectedTab === 'assigned_rankings')
      }"
    >
      <div
        v-if="!expandToRight"
        class="root-body-left"
        :class="{
          'root-body-left-countries': sector === 'countries' && !expandToRight,
          'root-body-left': sector !== 'countries' && !expandToRight
        }"
      >
        <!--        <Expansion-->
        <!--          :fetchT4="fetchT4"-->
        <!--          :background="background"-->
        <!--          v-show="expand"-->
        <!--          :alpha-sort="alphaOrder"-->
        <!--          :amount-sort="amountOrder"-->
        <!--          :campaign-tab="campaignTab"-->
        <!--          :expand-to-right="expandToRight"-->
        <!--          :main-table-reset="resetList"-->
        <!--          :page-num="currentPage"-->
        <!--          :query="externalSearchQuery"-->
        <!--          :query-object="queryObject"-->
        <!--          :question-id="questionId"-->
        <!--          :question-tab="questionTab"-->
        <!--          :search-params="searchParamsForExpansion"-->
        <!--          :sector="sector"-->
        <!--          :selected-items="selectedItems"-->
        <!--          :selected-main-tab="selectedMainTab"-->
        <!--          :selected-tab="selectedTab"-->
        <!--          :show="expand"-->
        <!--          :url-path="urlPath"-->
        <!--          @expansionDataReceived="handleExpansionData"-->
        <!--          @hideExpansionModule="expand = false"-->
        <!--          @totalCounts="setTotalCount"-->
        <!--        >-->
        <!--        </Expansion>-->
      </div>
      <div
        :class="{
          'root-body-right-for-dep': sector === 'deposits',
          'root-body-right-for-sms': sector === 'sms',
          'root-body-right-for-bad_number': sector === 'bad_number',
          'root-body-right-countries': sector === 'countries' && !expand,
          'root-body-right':
            sector !== 'countries' &&
            sector !== 'deposits' &&
            sector !== 'bad_number'
        }"
        :style="background.mainBg"
      >
        <top-multi-select-bar
          :style="background"
          :showExtMultiSelect="showExtMultiSelect"
          :selected-main-tab="selectedMainTab"
          :expand-to-right="expandToRight"
          v-show="open"
          :expand="expand"
          :ext-search="extSearch"
          :open="open"
          :page-num="currentPage"
          :query="externalSearchQuery"
          :query-object="queryObject"
          :sector="sector"
          :selected-tab="selectedTab"
          :stats-options="getData()"
          @excludeValueChanged="passExcludeValue($event)"
          @applyAlphaSorting="alphaSorting"
          @applyAmountSorting="amountSorting"
          @check_all="checkSelectAll"
          @conditionForFilteringMs="conditionForFilteringMs"
          @exclude="emitExclude"
          @searchParams="getSearchParams"
          @searching="showSearchResults"
          @show_expansion="showExpansion"
        ></top-multi-select-bar>

        <multi-select-tabs
          :expand="expand"
          :background="background"
          :expand-to-right="expandToRight"
          v-show="open"
          :has-tabs="hasTabs"
          :open="open"
          :sector="sector"
          @multiSelectTabChanged="createPath"
          @listOfTabs="setListOfTabs"
          @closeIt="open = false"
        ></multi-select-tabs>

        <check-box
            :exclude="exclude"
          :expand="expand"
          @check_all="checkSelectAll"
          :background="background"
          v-model="selectedItems"
          :alpha-sort="alphaOrder"
          :amount-sort="amountOrder"
          :changed-tab="changedTab"
          :check-all="checkAll"
          :expand-to-right="expandToRight"
          :expansion-data="getData()"
          :has-tabs="hasTabs"
          :loading="loader"
          :main-table-reset="resetList"
          :no-data="noData"
          :page-num="currentPage"
          :query-object="queryObject"
          :reset-multiselect="resetMs"
          :search-results="searchResults"
          :sector="sector"
          :selected-main-tab="selectedMainTab"
          :selected-tab="selectedTab"
          :show="expand"
          :stats-options="getData()"
          :stats-view-type="statsViewType"
          :total="total"
          :total-count="totalCount"
          @changeStatsView="changeStatsView"
          @sectorData="setSectorData"
          @transDirection="setTransDirection"
          @timeFrame="selectTimeFrame"
        >
        </check-box>

        <bottom-multi-select-bar
          :expand="expand"
          :expandToRight="expandToRight"
          :background="background"
          :campaign-tab="campaignTab"
          :page-num="currentPage"
          :pages="pageAmount"
          :query-object="queryObject"
          :sector="sector"
          :selected-tab="selectedTab"
          @close="$emit('close')"
          @apply="applyFiltering"
          @changePage="setPage"
          @depamount="emitDepAmount"
          @reset_multiselect="resetSelect"
          @show_statistics="setShowStatistics"
        ></bottom-multi-select-bar>
      </div>

      <!--      <div v-if="expandToRight" class="root-body-left">-->
      <!--        <Expansion-->
      <!--          :expand="expand"-->
      <!--          :fetchT4="fetchT4"-->
      <!--          :background="background"-->
      <!--          v-show="expand"-->
      <!--          :alpha-sort="alphaOrder"-->
      <!--          :amount-sort="amountOrder"-->
      <!--          :campaign-tab="campaignTab"-->
      <!--          :expand-to-right="expandToRight"-->
      <!--          :main-table-reset="resetList"-->
      <!--          :page-num="currentPage"-->
      <!--          :query="externalSearchQuery"-->
      <!--          :query-object="queryObject"-->
      <!--          :question-id="questionId"-->
      <!--          :question-tab="questionTab"-->
      <!--          :search-params="searchParamsForExpansion"-->
      <!--          :sector="sector"-->
      <!--          :selected-items="selectedItems"-->
      <!--          :selected-main-tab="selectedMainTab"-->
      <!--          :selected-tab="selectedTab"-->
      <!--          :show="expand"-->
      <!--          :url-path="urlPath"-->
      <!--          @expansionDataReceived="handleExpansionData"-->
      <!--          @hideExpansionModule="expand = false"-->
      <!--          @totalCounts="setTotalCount"-->
      <!--        >-->
      <!--        </Expansion>-->
      <!--      </div>-->

      <div :class="{ 'bottom-assignment': sector === 'assignments' }">
        <statistics-expansion
          :ms-selected-items="selectedItems"
          :open="open"
          :query-object="queryObject"
          :sector="sector"
          :campaign-tab="campaignTab"
          :initiated-filtering="initiatedFiltering"
          :show-statistics="showStatistics"
        >
        </statistics-expansion>
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";

import apiClientCreator from "@/helpers/api/request";
import CheckBox from "./CheckBox.component";
import MultiSelectTabs from "./MultiSelectTabs.component";
import { mapGetters, mapState } from "vuex";
import TopMultiSelectBar from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/TopMultiSelectBar";
import BottomMultiSelectBar from "./BottomMultiSelectBar";

import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import leads from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ld/leads";
import assignments from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/assignments/assignments";
import call_again from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/ca/call_again";
import deposits from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/dp/deposits";
import transfer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/tr/transfer";
import countries from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/countries/countries";
import sms from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/sms/sms";
import referral from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/referral/referral";
import no_answer from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/tabLists/no_answer/no_answer";
import StatisticsExpansion from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/MultiSelect/MultiSelect/StatisticsExpansion";
import moment from "moment";
import calendarCheck from "../../../../../../../mixins/tags/calendarCheck";
import QuestionsUtil from "./utils/questions_util";
import CampaignUtil from "./utils/campaign_util";
import _ from "lodash";

export default {
  name: "NewUniversalMultiSelect.container",
  mixins: [
    UsersPermissionCheck,
    leads,
    assignments,
    call_again,
    deposits,
    transfer,
    countries,
    sms,
    referral,
    no_answer,
    calendarCheck,
    QuestionsUtil,
    CampaignUtil
  ],
  components: {
    StatisticsExpansion,
    TopMultiSelectBar,
    BottomMultiSelectBar,
    MultiSelectTabs,
    CheckBox
  },
  props: {
    externalWidth: {
      type: Object
    },
    background: {
      type: Object
    },
    expandToRight: {
      type: Boolean,
      default: false
    },
    selectedMainTab: {
      type: String
    },
    hasTabs: {
      type: Boolean
    },
    countriesms: {
      type: Boolean,
      default: false,
      required: false
    },
    questionTab: {
      type: Boolean,
      required: false
    },
    questionId: {
      type: Number,
      required: false
    },
    campaignTab: {
      type: Boolean,
      required: false
    },
    extSearch: {
      type: Boolean,
      required: false
    },
    sector: {
      type: String
    },
    queryObject: {
      type: Object
    },
    open: {
      type: Boolean,
      default: false
    },
    resetList: {
      type: Boolean,
      default: false,
      required: false
    },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: false
    },
    placeH: {
      type: String,
      required: false
    },
    questionSector: {
      type: Number,
      required: false
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  data() {
    return {
      exclude:false,
      multiTimeOut:null,
      fetchT4: false,
      expansionData: [],
      statsViewType: 1,
      noData: false,
      selectedSectorData: {},
      resetMs: false,
      changedTab: false,
      searchParamsForExpansion: "",
      expand: false,
      selectedTab: "",
      msStats: {},
      showExtMultiSelect: false,
      selectedItems: [],
      checkAll: false,
      placeholder: this.sector,
      loader: false,
      searchResults: [],
      amountOrder: "asc",
      alphaOrder: "asc",
      externalSearchQuery: "",
      direction: 0,
      urlPath: "",
      pageAmount: 0,
      currentPage: 0,
      total: 0,
      totalCount: [],
      listOfTabs: [],
      showStatistics: false,
      tempParams: {},
      defaultParams: {},
      globalDateRange: "TODAY",
      fetchTimeOut: null,
      requestHash: null,
      timeFrame: null
    };
  },
  computed: {
    extWidth() {
      return {
        "--max-with": this.externalWidth.max,
        "--min-with": this.externalWidth.min
      };
    },
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "multiSelectChartData",
      "chartsViewBlocks",
      "multiSelectChartData",
      "showReset",
      "clickFromChart",
      "clientsTableSelectedTab",
      "generalQueryObject",
      "reOpenMultiCountry"
    ]),
    ...mapGetters("clients", [
      "getName",
      "getActives",
      "getDp",
      "showCart",
      "showCartMonth",
      "getMultiSelectChartData",
      "getChartsViewBlocks"
    ]),
    ...mapState("globalSearch",["currentSearch","currentAction"]),
    setStyleRoot() {
      ///TODO: GABI: ADD TO ARRAY ALL RELEVANT SECTORS TO LEFT OPEN EXTENSION TYPE
      const sectorsList = [
        "deposits",
        "leads",
        "referral",
        "placement",
        "questions_status",
        "call_again",
        "transfer",
        "no_answer",
        "questions",
        "keyword",
        "device",
        "click_type",
        "location",
        "advertising"
      ];
      if (sectorsList.includes(this.sector)) {
        return "right: 0px";
      } else {
        return "";
      }
    }
  },
  created() {
    this.defaultParams.deposits = {
      deposit_at_from: moment(this.defaultPresets().start).format("YYYY-MM-DD"),
      deposit_at_to: moment(this.defaultPresets().end).format("YYYY-MM-DD"),
      special_req: true
    };

    this.defaultParams.assignments = {
      active: 1
    };
  },
  mounted() {
    if(this.currentAction==="open_country_popup"&&this.sector==='countries'){
      this.openMultiSelect()
      this.$store.commit("globalSearch/setNewGlobalAction","open_country_popup")
    }
  },
  watch: {
    reOpenMultiCountry:function(){
if(this.reOpenMultiCountry){
if(this.sector === "countries"){
  this.open = true
  this.$store.commit("clients/setReOpenMultiCountry", false);
}
}
    },
    // chartsViewBlocks(){
    //
    // },
    "multiSelectChartData.hash": function() {
      if (
        this.multiSelectChartData.selectedSector === this.sector &&
        this.multiSelectChartData.fromChart
      ) {
        let tab = this.multiSelectChartData.data.hasOwnProperty(this.sector)
          ? this.multiSelectChartData.data[this.sector].selectedTab
          : false;
        if (tab) {

          this.selectedTab = tab;
          this.createPath(tab);
        } else {
          return;
        }
        //this.open = true;
      }
    },
    clientsTableSelectedTab: function() {
      if (
        this.clientsTableSelectedTab.tabAlias === "questions" &&
        this.sector === "questions" &&
        !this.open &&
        this.questionId === this.getQuestionsList()[0]
      ) {
        this.createPath("questions");
      } else if (
        this.clientsTableSelectedTab.tabAlias === "campaign" &&
        this.checkCampaignSector(this.sector, 1) &&
        !this.open
      ) {
        this.setCampaignsData(this.sector);
      } else if (
        this.clientsTableSelectedTab.tabAlias === "campaign-2" &&
        this.checkCampaignSector(this.sector, 2) &&
        !this.open
      ) {
        this.setCampaignsData(this.sector);
      }
    },
    clickFromChart: function() {
      if (
        this.clickFromChart &&
        this.clickFromChart.lastSector === this.sector
      ) {
        let emitNames = Object.keys(this.clickFromChart.data[this.sector]);
        if (this.hasTabs) {
          emitNames.forEach(tab => {
            this.$emit(
              tab.toLowerCase(),
              this.clickFromChart.data[this.sector][tab]
            );
          });
        }

        if (this.questionTab || this.campaignTab) {
          this.$emit("input", this.selectedItems);
        }
        this.$emit("apply");
      }
    },
    generalQueryObject() {
      if (
        (this.initiatedFiltering &&
          (this.open ||
            this.multiSelectChartData.selectedSector === this.sector)) ||
        this.getChartsViewBlocks.includes(this.sector)
      ) {
        if (this.hasTabs && this.selectedTab !== "dir") {
          this.fetchStats(this.selectedTab);
        }
        if (this.campaignTab) {
          this.createPath("campaign");
        }
        if (this.questionTab && this.sector === "questions") {
          this.createPath("questions");
        }

        if (this.questionTab && this.sector === "questions_status") {
          this.createPath("questions_status");
        }
      }
    },
    open() {
      if (this.open) {
        let chartObjOpt = Object.assign({}, this.multiSelectChartData);
        chartObjOpt.selectedSector = this.sector;
        chartObjOpt.fromChart = false;
        if (this.multiSelectChartData.selectedSector) {
          this.$store.commit("clients/setMultiSelectChartData", [
            chartObjOpt,
            this.sector
          ]);
        } else {
          this.$store.commit("clients/setMultiSelectChartData", chartObjOpt);
        }
        if (this.sector === "countries") {
          let calendarsArray = [
            "last_modified_na_from",
            "last_modified_na_to",
            "last_modified_lead_from",
            "last_modified_lead_to",
            "registered_on_from",
            "registered_on_to",
            "deposit_at_from",
            "deposit_at_to",
            "assigned_at_from",
            "assigned_at_to",
            "last_modified_from",
            "last_modified_to",
            "last_modified_personal_from",
            "last_modified_personal_to",
            "last_transfer_from",
            "last_transfer_to",
            "scheduled_call_to_from",
            "scheduled_call_to_to",
            "last_referral_from",
            "last_referral_to",
            "support_at_from",
            "support_at_to",
            "group_assigned_at_from",
            "group_assigned_at_to",
            "online"
          ];
          let yesOrNo = false;
          calendarsArray.forEach(item => {
            if (this.expand === false && this.selectedMainTab === "clients") {
              if (this.queryObject.hasOwnProperty(item) && yesOrNo === false) {
                this.fetchT4 = true;
                yesOrNo = true;
              }
            }
          });
        }
        if (this.sector === "finance_total") {
          this.createPath("finance_total");
        }
        if (this.sector === "finance_methods") {
          this.createPath("finance_methods");
        }
        if (this.sector === "finance_status") {
          this.createPath("finance_status");
        }
        if (this.sector === "finance_currency") {
          this.createPath("finance_currency");
        }
        if (this.sector === "bad_number") {
          this.createPath("bad_number");
        }
        if (this.sector === "not_interested") {
          this.createPath("not_interested");
        }

        if (this.campaignTab) {
          this.createPath("campaign");
        }
        if (this.questionTab && this.sector === "questions") {
          this.createPath("questions");
        }

        if (this.questionTab && this.sector === "questions_status") {
          this.createPath("questions_status");
        }
        if (this.hasTabs && this.selectedTab !== "dir") {
          this.createPath(this.selectedTab);
        }
      }
    },
    currentAction:function(){
      if(!this.currentAction) return;
      if(this.currentAction==="open_country_popup" && this.sector === 'countries'){
        this.openMultiSelect();
        this.$store.commit("globalSearch/setNewGlobalAction","")
      }
    }
  },

  methods: {
    passExcludeValue(event)
    {
      this.exclude = event;
      this.$emit('excludeValueChanged', event)
    },
    selectTimeFrame(timeFrame) {
      this.timeFrame = timeFrame;
      this.createPath(this.selectedTab);
    },
    checkSelectAll() {
      this.checkAll = !this.checkAll;
    },

    setListOfTabs(tabs) {
      this.listOfTabs = tabs;
    },

    setShowStatistics(data) {
      this.showStatistics = data;
    },

    handleExpansionData(data) {
      this.expansionData = data;
    },

    changeStatsView(type) {
      this.statsViewType = type;
    },
    setTotalCount(data) {
      this.totalCount = data;
    },
    setSectorData(data) {
      this.selectedSectorData = data;
    },
    emitDepAmount(amount) {
      this.$emit("depamount", amount);
    },
    setPage(page) {
      this.currentPage = page;
    },
    getSearchParams(searchParams) {
      this.searchParamsForExpansion = searchParams;
    },
    setPlaceHolder(questId = this.questionId) {
      if (this.questionTab && this.sector === "questions") {
        switch (questId) {
          case 1:
            return "Occupation";
          case 2:
            return "Trading signals";
          case 3:
            return "Trading experience";
          case 4:
            return "Invested";
          case 5:
            return "Expected profit";
          case 6:
            return "Invest plan";
          case 7:
            return "Broker";
          case 8:
            return "Number of signals";
          case 9:
            return "Trading reason";
          case 10:
            return "Originaly from";
          case 11:
            return "Age";
        }
        return this.placeH;
      }
      if (this.questionTab && this.sector === "questions_status") {
        return "STATUS";
      } else {
        return this.placeholder;
      }
    },
    extSearchStyle() {
      return this.questionTab
        ? "'min-width: 63px;' 'max-width: 63px;'"
        : "'min-width: 100px;' 'max-width: 100px'";
    },
    showExpansion() {
      this.expand = !this.expand;
    },

    setTransDirection(direction) {
      this.direction = direction.id;
    },
    amountSorting(order) {
      this.amountOrder = order;
    },
    alphaSorting(order) {
      this.alphaOrder = order;
    },
    // emitExclude(condition) {
    //   this.$emit("excludetag", condition);
    // },
    conditionForFilteringMs(condition) {
      this.$emit("conditionForFiltering", condition);
    },
    getData() {
      if (this.campaignTab) {
        return this.msStats[this.sector];
      } else {
        return this.msStats[this.selectedTab];
      }
    },

    applyFiltering() {
      if (this.selectedSectorData.hasOwnProperty("users")) {
        let data =
          this.selectedSectorData["users"].length > 0
            ? this.selectedSectorData["users"]
            : [];
        if (this.direction === 0) {
          this.$emit("transto", data);
        }
        if (this.direction === 1) {
          this.$emit("transfrom", data);
        }
        if (this.direction === 2) {
          this.$emit("transby", data);
        }
      }
      let emitNames = Object.keys(this.selectedSectorData);
      // if (this.hasTabs) {
        emitNames.forEach(tab => {
          this.$emit(tab, this.selectedSectorData[tab]);
        });
      // }
      if (this.questionTab || this.campaignTab) {
        this.$emit("input", this.selectedItems);
      }
      if (this.sector === "finance_total") {
        this.$emit("finance_categories", this.selectedItems);
      }
      if (this.sector === "finance_methods") {
        this.$emit("finance_methods", this.selectedItems);
      }
      if (this.sector === "finance_status") {
        this.$emit("finance_status", this.selectedItems);
      }
      if (this.sector === "finance_currency") {
        this.$emit("finance_currency", this.selectedItems);
      }
      this.$emit("apply");
    },

    showSearchResults(searchResults) {
      this.searchResults = searchResults;
    },

    openMultiSelect() {
      this.$store.commit("globalSearch/search","") // After opening multiselct , reseting the search.
      if (
        (this.sector === "assignments" && this.auth.user.role === 7) ||
        (this.sector === "no_answer" && this.auth.user.role === 7)
      ) {
        this.open = false;
      } else {
        if (this.sector === "assignments") {
          this.$store.commit("clients/setSelectedCalendarType", {
            alias: "ASSIGN",
            preset: null
          });
        }
        this.open = true;
      }
    },

    createPath(data) {
      let tab = data ? data.toLowerCase() : this.selectedTab;
      this.changedTab = true;
      this.total = 0;
      this.pageAmount = 0;
      this.currentPage = 0;
      this.noData = false;
      this.totalCount = [];
      this.expansionData = [];

      if (tab === "finance_total") {
        this.fetchStats(tab);
      }
      if (tab === "finance_methods") {
        this.fetchStats(tab);
      }
      if (tab === "finance_status") {
        this.fetchStats(tab);
      }
      if (tab === "finance_currency") {
        this.fetchStats(tab);
      }

      if (tab === "bad_number") {
        this.fetchStats(tab);
      }

      if (tab === "not_interested") {
        this.fetchStats(tab);
      }

      if (tab === "campaign") {
        this.fetchStats(tab);
      }
      if (tab === "questions") {
        this.fetchStats(tab);
      }
      if (tab === "questions_status") {
        this.fetchStats(tab);
      }

      this.searchResults = [];
      this.selectedTab = tab;

      if (this.hasTabs && tab !== "dir") {
        this.fetchStats(tab);
      }
    },

    fetchPath(rootPath,tab){
      clearTimeout(this.multiTimeOut)
      this.multiTimeOut = setTimeout(()=>{
        this.loader = true;

        this.urlPath = rootPath;
        let path = "";

        if (this.expand) {
          rootPath = `${this.urlPath}/?with_expand=true`;

          if (this.fetchT4) {
            rootPath = `${this.urlPath}/?with_expand=true&fetch_t4=1`;
          }
        }
        this.msStats[tab] = [];
        this.requestHash = Math.floor(Math.random() * 10000) + 1;
        if (this.sector === "countries" && this.timeFrame) {
          this.tempParams.time_frame = this.timeFrame;
        }
        apiClientCreator(rootPath)
            .get("", {params: {...this.tempParams, hash: this.requestHash}})
            .then(res => {
              // if(this.requestHash === )
              if (this.requestHash === res.config.params.hash) {
                let hash = Math.floor(Math.random() * 10000) + 1;
                if (res.data.length < 1) {
                  this.noData = true;
                }
                if (
                    this.multiSelectChartData.selectedSector === this.sector ||
                    this.getChartsViewBlocks.includes(this.sector)
                ) {
                  let chartData = {
                    mainSector: this.sector,
                    selectedTab: this.selectedTab,
                    valid: true,
                    data: res.data,
                    fromChart: false,
                    tabsList: this.listOfTabs,
                    hash: hash
                  };
                  if (this.sector === "questions") {
                    chartData = {
                      ...chartData,
                      questions: 1,
                      qLabel: this.setPlaceHolder(this.questionId)
                    };
                  }
                  this.$store.commit("clients/setMultiSelectChartData", [
                    chartData,
                    this.sector
                  ]);
                }

                this.placeholder = this.sector;
                if (this.campaignTab || this.questionTab) {
                  this.msStats[this.sector] = res.data;
                  this.pageAmount = this.msStats[this.sector].length;
                  this.getTotal(res.data);
                } else {
                  this.msStats[tab] = res.data;
                  this.pageAmount = this.msStats[tab].length;
                  this.getTotal(res.data);
                }
                this.loader = false;
              }
            })

            .catch(err => {
              this.loader = false;
              this.noData = true;
            });

        if (this.sector === "questions") {
          if (this.getChartsViewBlocks[1] !== "questions") {
            //return;
          }
          this.setQuestionsData();
        }
      },1000)

    },


    fetchStats(tab) {
      if (!tab) {
        return;
      }

        if (
            this.checkIfCalendarSelected() &&
            this.CheckUserPermission([1, 2, 3, 4, 12]) &&
            this.open &&
            this.selectedMainTab === "total"
        ) {
          this.expand = true;
        } else {
          this.expand = false;
        }
        if (
            (this.sector === "questions" &&
                !this.open &&
                this.clientsTableSelectedTab.tabAlias !== "questions") ||
            (this.sector === "questions" &&
                !this.open &&
                this.clientsTableSelectedTab.tabAlias === "questions" &&
                this.questionId !== this.getQuestionsList()[0])
        ) {
          return;
        }
        this.tempParams = Object.assign({}, this.queryObject);
        if (!this.showReset) {
          if (this.defaultParams.hasOwnProperty(this.sector)) {
            this.tempParams = Object.assign({}, this.defaultParams[this.sector]);
          }
        }

        this.loader = true;
        if(this.hasTabs){
          let tabs = this[this.sector].find(key=>{
            return key.alias.toUpperCase() === tab.toUpperCase();
          })
          if(!tabs){
            return;
          }
        }
        let rootPath = `client/stats/multiselect/${this.sector}/${tab}`;
        if (this.fetchT4) {
          rootPath = `client/stats/multiselect/${this.sector}/${this.selectedTab}`;
        }

        if (
            tab === "bad_number" ||
            tab === "not_interested" ||
            tab === "campaign"
        ) {
          rootPath = `client/stats/multiselect/${this.sector}`;
        }
        if (this.sector === "transfer" && this.selectedTab === "users") {
          rootPath = `client/stats/multiselect/transfer/users/${this.direction}`;
        }

        if (this.questionTab && this.sector === "questions") {
          rootPath = `client/stats/multiselect/${this.sector}/${this.questionId}`;
        }
        if (this.questionTab && this.sector === "questions_status") {
          rootPath = `client/stats/multiselect/questions/${this.sector}`;
        }

        if (this.sector === "finance_total") {
          rootPath = `finance/multiselect/finance/total/${this.sector}`;
        }
        if (this.sector === "finance_methods") {
          rootPath = `finance/multiselect/finance/total/${this.sector}`;
        }
        if (this.sector === "finance_status") {
          rootPath = `finance/multiselect/finance/total/${this.sector}`;
        }
        if (this.sector === "finance_currency") {
          rootPath = `finance/multiselect/finance/total/${this.sector}`;
        }
        if (
            this.open ||
            this.multiSelectChartData.selectedSector === this.sector ||
            this.getChartsViewBlocks.includes(this.sector) ||
            (this.clientsTableSelectedTab.tabAlias === "questions" &&
                this.sector === "questions" &&
                !this.open &&
                this.questionId === this.getQuestionsList()[0])
        ) {
        this.fetchPath(rootPath,tab)
        }
    },

    getTotal(data) {
      if (data.length > 0) {
        const reducer = (accumulator, currentValue) =>
          accumulator + currentValue;
        this.total = data
          .map(s => s.count[0])
          .flat(Infinity)
          .reduce(reducer);
      } else {
        this.total = 0;
      }
    },

    paginate(stats) {
      let pageSize = 10;

      let inputArray = stats;

      let result = inputArray.reduce((resultArray, item, index) => {
        const pageIndex = Math.floor(index / pageSize);

        if (!resultArray[pageIndex]) {
          resultArray[pageIndex] = []; // start a new page
        }

        resultArray[pageIndex].push(item);

        return resultArray;
      }, []);

      return result;
    },
    outClose() {
      if (
        this.open &&
        (this.sector === "assignments" ||
          this.sector === "questions" ||
          this.sector === "countries" ||
          this.sector === "sms" ||
          this.sector === "bad_number" ||
          this.sector === "finance_total" ||
          this.sector === "finance_methods" ||
          this.sector === "finance_status" ||
          this.sector === "finance_currency" ||
          this.selectedTab === "campaign" ||
            this.sector === "not_interested" ||
          this.showStatistics === true)
      ) {
        this.applyFiltering();
        this.closeSelect();
      }
    },

    closeSelect() {
      this.expand = false;
      this.open = false;
      if (this.sector === "bad_number" || this.sector === "not_interested") {
        this.$emit("close");
      }
    },
    resetSelect() {
      this.noData = false;
      this.selectedSectorData = {};
      this.resetMs = !this.resetMs;
      // this.$emit("input", this.selectedItems);
      this.selectedItems = [];
      this.$emit("reset");
    },

    defaultPresets(range = this.globalDateRange) {
      if (range === "TODAY") {
        const n = new Date();
        const today = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          start: today,
          end: today
        };
      }
      if (range === "YESTERDAY") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 1)
        );
        // const end = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()))
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "WEEK") {
        const n = new Date();
        const start = moment()
          .startOf("isoWeek")
          .toDate();
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0)
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "MONTH") {
        const n = new Date();
        const startMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 1));
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
      if (range === "LAST_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() - 1, 1)
        );
        const endMonth = new Date(Date.UTC(n.getFullYear(), n.getMonth(), 0));
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }

      if (range === "LAST_30_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 30)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_90_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 90)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "LAST_180_DAYS") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() - 180)
        );
        const end = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())
        );
        return {
          dateRange: {
            start: start,
            end: end
          }
        };
      }
      if (range === "TOMORROW") {
        const n = new Date();
        const start = new Date(
          Date.UTC(n.getFullYear(), n.getMonth(), n.getDate() + 1)
        );
        return {
          dateRange: {
            start: start,
            end: start
          }
        };
      }
      if (range === "NEXT_MONTH") {
        const n = new Date();
        const startMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 1, 1)
        );
        const endMonth = new Date(
          Date.UTC(n.getFullYear(), n.getMonth() + 2, 0)
        );
        return {
          dateRange: {
            start: startMonth,
            end: endMonth
          }
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$maxWidth: var(--max-width);
$minWidth: var(--min-width);
input[type="search"]:focus {
  outline: none !important;
}

.root {
  position: relative;
  /*top: 0;*/
  /*left: 0;*/
  /*width: max-content;*/
}

.root-body {
  position: absolute;
  /*<!--top: -212px;-->*/
  top: 63px;
  right: -450px !important;
  width: max-content;
  z-index: 10002;
  /*background-color: #fb9324;*/
  display: flex;
  font-family: Montserrat;
  /*max-height: 256px;*/
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-campaign {
  position: absolute;
  top: 80px;
  right: 121px !important;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-for-bn {
  position: absolute;
  top: 300px;
  /* right: -256px; */
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border-radius: 7px;
  padding: 7px 21px 6px 21px;
}
.root-body-for-ni {
  position: absolute;
  top: 0;
  /* right: -256px; */
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border-radius: 7px;
  padding: 7px 21px 6px 21px;
}
.root-body-assignments {
  position: absolute;
  top: 63px;
  right: -660px !important;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
}
.root-body-assignments-no-ex {
  position: absolute;
  top: 67px;
  left: 180px !important;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  min-width: 429px !important;
  z-index: 10002;
  background-color: #abce40 !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  padding: 0px 20px 7px 20px;
  border-right: 7px;
  border-radius: 7px;
}
/*<!--.root-body-campaign {-->*/
/*<!--  position: absolute;-->*/
/*<!--  !*&lt;!&ndash;top: -212px;&ndash;&gt;*!-->*/
/*<!--  top: 63px;-->*/
/*<!--  right: -50px !important;-->*/
/*<!--  width: max-content;-->*/
/*<!--  z-index: 10002;-->*/
/*<!--  !*background-color: #fb9324;*!-->*/
/*<!--  display: flex;-->*/
/*<!--  font-family: Montserrat;-->*/
/*<!--  !*max-height: 256px;*!-->*/
/*<!--  max-height: fit-content;-->*/
/*<!--  border: 1px solid unset;-->*/
/*<!--  border-radius: 7px;-->*/
/*<!--  padding: 0 15px 0px 15px;-->*/
/*<!--}-->*/
.root-body-campaign-placement {
  position: absolute;
  top: 0;
  right: 80px !important;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-questions-status {
  position: absolute;
  top: 78px;
  left: -353px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-questions {
  position: absolute;
  top: 80px;
  right: 155px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: grey;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-countries {
  position: absolute;
  top: 57px;
  right: -393px !important;

  width: 413px;
  z-index: 10002;
  background-color: gray;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-countries-expand {
  position: absolute;
  /*<!--top: -212px;-->*/
  top: 63px;
  right: -625px !important;
  /*<!--right: -650px !important;-->*/
  width: max-content;
  z-index: 10002;
  background-color: gray;
  display: flex;
  font-family: Montserrat;
  /*max-height: 256px;*/
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
}
.root-body-for-dep {
  top: 63px;
  position: absolute;
  right: 0 !important;
  /*width: -webkit-max-content;*/
  /*width: -moz-max-content;*/
  /*width: max-content;*/
  /*min-width: 750px !important;*/
  z-index: 10002;
  /* background-color: #fb9324; */
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  border: 1px solid unset;
  border-radius: 7px;
  padding: 0 15px 0px 15px;
  min-width: 700px !important;
}
.r-body-ex-right {
  position: absolute;
  top: -188px;
  width: max-content;
  z-index: 10002;
  background-color: #fff;
  display: flex;
  left: 177px;
  font-family: Montserrat;
}
.r-body-ex-right-finance-category {
  position: absolute;
  width: max-content;
  z-index: 10002;
  background-color: #fff;
  display: flex;
  left: 177px;
  font-family: Montserrat;
}

.r-body-ex-right-finance-methods {
  position: absolute;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 939px;
  top: 363px;
}
.r-body-ex-right-finance-status {
  position: absolute;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 939px;
  top: 363px;
}
.r-body-ex-right-finance-currency {
  position: absolute;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 939px;
  top: 363px;
}
.r-body-ex-right-ranks {
  position: absolute;
  top: -63px;
  left: 180px !important;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  min-width: 429px !important;
  z-index: 10002;
  background-color: #abce40 !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-family: Montserrat;
  /* max-height: 256px; */
  max-height: -webkit-fit-content;
  max-height: -moz-fit-content;
  max-height: fit-content;
  padding: 0px 20px 7px 20px;
  border-right: 7px;
}
.r-body-ex-right-sms {
  osition: absolute;
  top: 354px;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  z-index: 10002;
  background-color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  left: 244px;
  font-family: Montserrat;
}
.input-main-multi-select {
  position: relative;
  display: inline-block;
  border: 1px solid #d7d7d7;
  height: 30px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  text-transform: capitalize;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 5px;
  min-width: 100%;
}

.input-main-assignments {
  max-width: $maxWidth;
  min-width: $minWidth;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  //border: 1px solid #546e7a;
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  text-transform: capitalize;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /* margin-bottom: 5px; */
  background: #f5f7ff;
  border-radius: 5px;
  font-weight: 800 !important;
  color: #546e7a !important;

  /*min-width: 100%;*/
  /*max-width: 100%;*/
  /*position: relative;*/
  /*display: inline-block;*/
  /*padding: 4px 4px 4px 10px;*/
  /*border: 1px solid white;*/
  /*height: 30px;*/
  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  /*font-size: 11px;*/
  /*text-transform: capitalize;*/
  /*-webkit-appearance: none;*/
  /*-moz-appearance: none;*/
  /*-o-appearance: none;*/
  /*box-sizing: border-box;*/
  /*!*margin-bottom: 5px;*!*/
  /*background: #f5f7ff;*/
  /*border-radius: 5px;*/
  /*font-weight: 600;*/
}

.time-select {
  cursor: pointer;
  margin-left: 5px;
  width: 0px;
  height: 30px;
  padding: 3px 20px 3px 10px;
  border-radius: 4px;
  /*border: 1px solid #dee2e6;*/
  color: black;
  background: #fff;
  margin-top: 1px;
  max-width: 100%;
  font-size: 10pt;
  background: url(/img/icons/globe.svg) no-repeat right #f5f7ff;
  /*font-weight: bold;*/
  background-size: 18px;
  background-position: 50% 5px;
  transition-duration: 0.4s;

  //border: 1px solid #546e7a;
}

.root-body-right {
  float: right;
  width: fit-content;
  /*max-width: 400px;*/
  border: 1px solid unset;
  border-radius: 0 7px 7px 0;
  background-color: grey;
  min-width: 450px !important;
}
.root-body-right-countries {
  float: right;
  width: fit-content;
  max-width: 400px;
  border: 1px solid unset;
  border-radius: 0 7px 7px 0;
  background-color: grey;
  /*padding: 0 15px 0px 15px;*/
}
.root-body-right-for-dep {
  float: right;
  /*width: 700px;*/
  max-width: max-content;
  border: 1px solid unset;
  border-radius: 0 7px 7px 0;
}
.root-body-right-for-bad_number {
  float: right;
  /*width: 700px;*/
  max-width: max-content;
  border: 1px solid unset;
  /*border-radius: 0 7px 7px 0;*/
}
.root-body-right-for-sms {
  max-width: max-content;
  border: 1px solid unset;
  float: right;
  padding: 0 15px 0px 15px;
  border-radius: 7px;
}
.root-body-right-assignments {
  float: right;
  width: fit-content;
  max-width: 700px;
  border: 1px solid unset;
  border-radius: 0 7px 7px 0;
  background-color: rgb(171, 206, 64) !important;
  /*padding: 0 15px 0px 15px;*/
  direction: rtl;
}

.root-body-left {
  float: left;
}
.root-body-left-countries {
  float: left;
  background-color: grey;
}

.sms-ext-button {
  width: 35px;
  margin-left: 4px;
  position: relative;
  padding-top: 6px;
  border-radius: 5px;
  border: 1px solid #d7d7d7;
  /*border: 1px solid white;*/
  /*border-right: 5px !important;*/
  //background: #f5f7ff;
  height: 30px;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  cursor: pointer;
  transition-duration: 0.4s;
  //border: 1px solid #546e7a;
}

.sms-ext-button:hover {
  background-color: #e0e0e0;
}
.input-main-multi-select::-webkit-input-placeholder {
  text-align: center;
}

th.th-question-11 div.floating-wrapper input.input-main-multi-select,
th.th-question-3 div.floating-wrapper input.input-main-multi-select,
th.th-question-7 div.floating-wrapper input.input-main-multi-select {
  min-width: 54%;
}
th.th-question-11 div.floating-wrapper > div,
th.th-question-3 div.floating-wrapper > div,
th.th-question-7 div.floating-wrapper > div {
  text-align: right;
}

.th-loc-phys .input-main-multi-select,
.th-kyword .input-main-multi-select,
th-device .input-main-multi-select,
th-campaign-id .input-main-multi-select,
th-click-on-site .input-main-multi-select {
  /*min-width: 50%;*/
}

th[class*="question"] .input-main-multi-select {
  min-width: 44% !important;
}

.th-question-11 .input-main-multi-select {
  min-width: 44%;
}
th.th-question-11 div.floating-wrapper > div[data-v-4517705f] {
  text-align: unset;
}
th.th-question-7 div.floating-wrapper > div[data-v-4517705f] {
  text-align: unset;
}
th.th-question-3 div.floating-wrapper > div[data-v-4517705f] {
  text-align: unset;
}
.root-body-right-assignments {
  /*padding: 0 15px 9px 15px;*/
}
.input-filter-category {
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 4px;
  border: 1px solid transparent;
  height: 20px;
  width: 100%;
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 11px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  background: #f5f7ff;
  border-radius: 5px;
  min-width: 61%;
}

.input-filter-category::-webkit-input-placeholder {
  color: black;
}
.gary-back{
  background-color: #767575;
  cursor: not-allowed;
}
</style>
